import { normalizeSelectionBrands } from './brands';

const getRowBrandCodes = (row) => {
  if (!row) return [];
  const source = row.sourceEnrollment || row.source || row;
  const candidates = [
    // Common: pre-normalized arrays
    row.brandsCodes,
    row.brandCodes,
    // Common: display strings / name arrays
    row.brandsDisplay,
    row.brandsCsv,
    row.brandNames,
    row.brandName,
    row.brands,
    row.brand,
    // Fallback: single brand tokens
    row.gmBrandCd,
    row.brandCd,
    row.brandCode,
    // Nested payloads (Status Changes often includes `sourceEnrollment`)
    source?.brandsCodes,
    source?.brandCodes,
    source?.brandsDisplay,
    source?.brandsCsv,
    source?.brandNames,
    source?.brandName,
    source?.brands,
    source?.brand,
    source?.gmBrandCd,
    source?.brandCd,
    source?.brandCode,
  ];

  // Important: don't stop at empty arrays/empty strings (Status Changes often has `brandsCodes: []`
  // but a meaningful `brandsDisplay` like "CG").
  for (const raw of candidates) {
    if (raw == null) continue;
    if (Array.isArray(raw) && raw.length === 0) continue;
    if (typeof raw === 'string' && raw.trim() === '') continue;
    const normalized = normalizeSelectionBrands(raw);
    if (Array.isArray(normalized?.codes) && normalized.codes.length > 0) return normalized.codes;
  }
  return [];
};

const resolveDiStatusValue = (row, di) => {
  return (
    di?.diStatus ||
    di?.status ||
    row?.diStatus ||
    row?.di?.diStatus ||
    row?.di?.status ||
    row?.diStatusLabel ||
    row?.diStatusName ||
    row?.diStatusText ||
    row?.diStatusDescription ||
    ''
  );
};

const normalizeComparableStatus = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim().toLowerCase();
};

const computeStatusMatch = (row) => {
  if (!row) return false;
  const dpe = normalizeComparableStatus(
    row?.productSelectionStatus ?? row?.productSelectionStatusCd ?? row?.status ?? ''
  );
  const di = normalizeComparableStatus(row?.diStatusResolved ?? row?.diStatus ?? '');
  if (!dpe || !di) return false;
  return dpe === di;
};

const getStatusMatchMeta = (isMatch) => ({
  label: isMatch ? 'true' : 'false',
  color: isMatch ? 'success' : 'error',
});

const buildEnrollmentInfoFields = (row) => {
  if (!row) return null;
  const enrollment = row.sourceEnrollment || row.source || row;
  const dealerName =
    enrollment?.dealerName ??
    row?.dealerName ??
    row?.dealer?.dealerName ??
    row?.dealerNameDisplay ??
    '';
  const brands = row?.brandsDisplay ?? enrollment?.brandsDisplay ?? '';
  return { dealerName, brands };
};

const resolveSelectionForStaging = (row) => {
  if (!row) return null;
  if (row.sourceSelection) return row.sourceSelection;
  if (row.source?.sourceSelection) return row.source.sourceSelection;

  // If the row looks like a selection (selection-level fields exist), prefer the row itself.
  const looksSelectionLike = Boolean(
    row.serviceItemName ||
      row.productBrandCode ||
      row.productBrandCd ||
      row.productCd ||
      row.vendorCode ||
      row.vendorCd ||
      row.vendorName ||
      row.referenceId ||
      row.productSelectionStatus ||
      row.billingStartDate ||
      row.productSelectionDate
  );
  if (looksSelectionLike) return row;

  // Fallback: enrollment-ish row.
  return row.sourceEnrollment || row.source || row;
};

export {
  buildEnrollmentInfoFields,
  computeStatusMatch,
  getRowBrandCodes,
  getStatusMatchMeta,
  normalizeComparableStatus,
  resolveDiStatusValue,
  resolveSelectionForStaging,
};
